import React, { useState, useRef } from "react";
import { Form, Modal } from "react-bootstrap";
import _ from "lodash";
import { renderQCCheckListFormFields } from "../form/FormRenderer";
import ConfigUtils from "../../utils/ConfigUtils";
import {StyledBlackButton, StyledBlueButton} from "../../styles/BootstrapStyles";

const QCCheckList = ({ onComplete, onCancel, show, job, onClose }) => {
  const qcFields = ConfigUtils.getQCFields();
  const modalRef = useRef();
  const [qcList, setList] = useState(_.get(job, "processor.transcodeQualityCheck", {}));
  const readOnlyF = !_.includes(["WF_QC_PENDING", "WF_QC_IN_PROGRESS"], _.get(job, "status"));
  const [error, setError] = useState({});
  const jobType = _.get(job, "jobType");
  const fieldsConfig = _.get(qcFields, jobType, _.get(qcFields, "default"));

  const handleOption = (field, value) => {
    setList({ ...qcList, [field]: value });
  };
  const handleClose = () => {
    onClose();
  };
  const handleCancel = () => {
    const hasProgress = !_.isEmpty(_.omit(qcList, "jobId"));
    onCancel(hasProgress);
  };
  const handleSave = (e) => {
    e.preventDefault();
    let qcDone = _.get(e.currentTarget, "id") === "save" ? false : true;
    let values = {};
    let fieldValue = { ...qcList };
    let errorValue = {};
    _.map(fieldsConfig, (field) => {
      if (_.has(field, "ref")) {
        if (_.get(field, "type") === "radio") {
          values[field.ref] = _.get(fieldValue, field.ref, "");
          if (_.isEmpty(values[field.ref]) && field.required && _.get(e.currentTarget, "id") !== "save") {
            errorValue[field.ref] = "Please fill out this field";
          }
        } else {
          values[field.ref] = _.get(fieldValue, field.ref, "");
        }
      }
    });
    values["qcDone"] = qcDone;
    if (!_.isEmpty(errorValue)) {
      setError(errorValue);
    } else {
      setError({});
      onComplete(values, qcDone);
    }
  };

  return (
    <Modal
        ref={modalRef} id="qc_checklist_modeal"
        backdrop="static"
        className="modal"
        show={show}
        size="lg"
        dialogClassName="modalDialog"
        onHide={handleClose}>
      <Modal.Header className="modalHeader" closeButton>
        <Modal.Title className="modalHeaderTitle">QC Checklist</Modal.Title>
      </Modal.Header>
      <Form id="qcCheckList_form" onSubmit={readOnlyF ? handleCancel : handleSave}>
        <Modal.Body className="modalBody">
          {_.isEmpty(fieldsConfig) ? null : renderQCCheckListFormFields(
              fieldsConfig, !readOnlyF, handleOption, qcList, error)}
          <Form.Row
            style={{
              margin: "10px 0 0 0",
              display: "flex",
              justifyContent: "flex-end",
            }}>
            {readOnlyF ? null : (
              <>
                <StyledBlueButton id="qcDone" type="submit">
                  QC Done
                </StyledBlueButton>
                <StyledBlueButton id="save" onClick={handleSave}>
                  Save Progress
                </StyledBlueButton>
              </>
            )}
            <StyledBlackButton onClick={handleCancel}>
              {readOnlyF ? "Close" : "Cancel"}
            </StyledBlackButton>
          </Form.Row>
        </Modal.Body>
      </Form>
    </Modal>
  );
};

QCCheckList.defaultProps = {
  onComplete: null,
  onCancel: null,
  show: false,
  job: {},
  onClose: null,
};
export default React.memo(QCCheckList);
